'use client';

import { Box } from '@terra/ui-styled-system';
import { CollaborationPanel } from './CollaborationPanel';
import { CoPilotChat } from '../CoPilotChat';
import { ErrorBoundary } from '../ErrorBoundary';
import type { CommentEntityType } from '@terra/shared-contracts-comments';
import {
  useRightPanelView,
  type MainContentTab,
} from '../../store/layoutStore';

type RightPanelProps = {
  entityType: CommentEntityType;
  entityId: string | undefined;
  entityName?: string;
  tabType?: MainContentTab;
  onMinimize?: () => void;
  isHistoryOpen?: boolean;
  onCopilotHistoryOpenChange?: (isOpen: boolean) => void;
};

export function RightPanel({
  entityType,
  entityId,
  entityName,
  tabType,
  onMinimize,
  isHistoryOpen,
  onCopilotHistoryOpenChange,
}: RightPanelProps) {
  const { rightPanelView: activeView } = useRightPanelView();

  if (activeView === 'copilot') {
    return (
      <Box
        h="full"
        w="full"
        bg="bg.subtle"
        display="flex"
        flexDirection="column"
      >
        <Box flex="1" overflow="hidden">
          <ErrorBoundary scopeId="copilot-panel">
            <CoPilotChat
              onMinimize={onMinimize}
              isHistoryOpen={isHistoryOpen}
              onHistoryOpenChange={onCopilotHistoryOpenChange}
            />
          </ErrorBoundary>
        </Box>
      </Box>
    );
  }

  return (
    <Box h="full" w="full" bg="bg.subtle" display="flex" flexDirection="column">
      <Box flex="1" overflow="hidden">
        <CollaborationPanel
          entityType={entityType}
          entityId={entityId}
          entityName={entityName}
          tabType={tabType}
          onMinimize={onMinimize}
        />
      </Box>
    </Box>
  );
}
